<div class="container">
  <div class="loader" *ngIf="isLoading"></div>
  <!-- <div class="loading" *ngIf="isLoading">
      <div
        class="spinner-border"
        role="status"
        style="
          width: 7rem;
          height: 7rem;
          font-size: 4rem;
          left: 50%;
          position: fixed;
          top: 40%;
        "
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div> -->
</div>
